import { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button, Grid, IconButton, Container, Paper, Typography, Card, CardContent, Stack, Box, Avatar, Divider, Chip } from "@mui/material";

// Servicios
import UserContextP from "Interfaces/Context";
import { auth, logout } from "Service/Connections";

// Iconos
import DiscountIcon from '@mui/icons-material/Discount';
import LogoutIcon from '@mui/icons-material/Logout';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import ReportOffIcon from '@mui/icons-material/ReportOff';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import Loader from "Components/Loader";

const ListDocument = () => {
    const context = useContext(UserContextP)
    const navigate = useNavigate()
    const [errorLogin, setErrorLogin] = useState(false)
    const [errorServer, setErrorServer] = useState(false)
    const [dataOrder, setDataOrder] = useState<any>()
    const [loader, setLoader] = useState(true)

    //Funcion de carga
    useEffect(() => {
        document.title = "Ordenes Nuevas"
        if (context.user.id === "" && context.authenticate.uid === "") {
            auth.onAuthStateChanged(async(response) => {
                console.log(response)
                if ( response !== null ) {
                    await axios.get(`${process.env.REACT_APP_URL_ORDER}/api/v1/auth/generate/token`, {
                        headers:{
                            Authorization: `UserId ${response.uid}`
                        }
                    }).then((res) => {
                        context.assignUser(
                            response.uid, 
                            res.data?.data?.user?.last_name ?? "", 
                            res.data?.data?.user?.name ?? "",
                            res.data?.data?.user?.email ?? "" 
                        )                        
                        context.assignateAuth(response.uid ?? "", true,  res.data?.data?.token ?? "")
                    }).catch(() => navigate("/auth/signin") )
                } else navigate("/auth/signin")
            })
        }
        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        console.log(context.user)
        if (context.user.id !== "" && context.authenticate.uid !== "") getDataOrder()

        // eslint-disable-next-line
    }, [context.user, context.authenticate, context.authenticate.uid])


    //Obtiene la informacion de las ordenes
    const getDataOrder = async () => {
        await axios.get(`${process.env.REACT_APP_URL_ORDER}/api/v1/orders/pending`,{
            headers: {
                Authorization: `Bearer ${context.authenticate.token}`
            },
            params: {
                canceled: false
            }
        }).then((response) => setDataOrder(response.data.data))
        .catch((error) => {
            setErrorLogin(() => error.response.status === 403 || error.response.status === 401)
            setErrorServer(() => error.response.status !== 403 && error.response.status !== 401)
        }).finally(()=> setLoader(false))
    }

    //Metodo para navegar al detalle de la orden
    const navigateTo = (item: any) => {
        context.assignateCopyData({ order: item })
        navigate(item.$key)
    }

    const closeSession = async () => {
        context.assignUser("","","","")
        context.assignateAuth("", false, "")
        await logout()
        navigate("/auth/signin")
    }
    return (
        <Container maxWidth="lg" sx={{ py: 3 }}>
            {loader ? (
                <Loader openLoader={loader} inPage={true} redirect={false} />
            ) : errorServer ? (
                <Paper sx={{ p: 4, textAlign: 'center' }}>
                    <ReportOffIcon sx={{ fontSize: 120, color: 'error.main' }} />
                    <Typography variant="h5" sx={{ mt: 2 }}>¡Algo salió mal!</Typography>
                    <Typography sx={{ mt: 1 }}>El recurso que está intentando acceder no está disponible</Typography>
                </Paper>
            ) : errorLogin ? (
                <Paper sx={{ p: 4, textAlign: 'center' }}>
                    <NoAccountsIcon sx={{ fontSize: 120, color: 'error.main' }} />
                    <Typography variant="h5" sx={{ mt: 2 }}>¡No tienes permisos para acceder a esta sección!</Typography>
                    <Typography sx={{ mt: 1 }}>Necesita acceder a su cuenta y/o con credenciales suficientes para poder visualizar este contenido</Typography>
                    <Button variant="contained" sx={{ mt: 2 }} onClick={closeSession}>Cerrar sesión</Button>
                </Paper>
            ) : (
                <Paper sx={{ p: { xs: 2, md: 4 } }}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <IconButton onClick={closeSession} aria-label="Cerrar sesión">
                            <LogoutIcon />
                        </IconButton>
                    </Box>

                    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems="center" sx={{ mb: 2 }}>
                        <Box component="img" src={require('Media/Logo.png')} alt="Logo premier tools" sx={{ height: 120 }} />
                        <Box>
                            <Typography variant="h4" sx={{ color: '#112a56' }}>Órdenes en revisión</Typography>
                            <Typography variant="body1">Hola {context.user.name}, este es el listado de ordenes pendientes</Typography>
                        </Box>
                    </Stack>

                    <Divider sx={{ my: 2 }} />

                    {dataOrder?.length > 0 ? (
                        <Stack spacing={2}>
                            {dataOrder.map((item: any, index: number) => (
                                <Card key={item.$key ?? index} variant="outlined" sx={{ cursor: 'pointer' }} onClick={() => navigateTo(item)}>
                                    <CardContent>
                                        <Grid container spacing={1} alignItems="center">
                                            <Grid item xs={12} md={8}>
                                                <Stack direction="row" spacing={2} alignItems="center">
                                                    <Avatar sx={{ bgcolor: item.type === 'PurchaseOrder' ? '#bf700f' : '#248c4c' }}>
                                                        {item.type === 'PurchaseOrder' ? <ArchiveIcon /> : <UnarchiveIcon />}
                                                    </Avatar>
                                                    <Box>
                                                        <Typography variant="h6" sx={{ m: 0 }}>{item.cardName} - #{item.numberOrder}</Typography>
                                                        <Typography variant="body2" color="text.secondary">{item.type === 'PurchaseOrder' ? 'Orden de compra' : 'Orden de venta'}</Typography>
                                                    </Box>
                                                </Stack>
                                            </Grid>

                                            <Grid item xs={12} md={4}>
                                                <Box sx={{ textAlign: { xs: 'left', md: 'right' } }}>
                                                    {item.discount > 0 && <Chip icon={<DiscountIcon />} label="Orden con descuento" color="success" sx={{ mb: 1 }} />}
                                                    <Typography variant="body2">{typeof item.payToCode === 'string' ? item.payToCode : '-'}</Typography>
                                                    <Typography variant="caption" display="block">{item.facSerie === 'CCF' ? 'Crédito Fiscal' : 'Consumidor Final'}</Typography>
                                                    <Typography variant="subtitle2" sx={{ mt: 1 }}>Total: {(process.env.REACT_APP_CURRENCY ?? '$') + ' ' + (item.total?.toFixed(2) ?? '0.00')}</Typography>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} justifyContent="space-between" alignItems="center">
                                                    <Box>
                                                        <Typography variant="body2">Solicitada por: {item.vendorName}</Typography>
                                                        <Typography variant="body2">Hora de la orden: {item.date}</Typography>
                                                    </Box>
                                                    <Box>
                                                        {item?.authorized?.length > 0 && (
                                                            <Typography variant="body2" color="success.main" sx={{ fontWeight: 'bold' }}>
                                                                {item?.authorized[0]?.userId === context.user.id ? 'Esta orden ya la autorizó' : 'Autorizada'}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Stack>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            ))}
                        </Stack>
                    ) : (
                        <Box sx={{ textAlign: 'center', py: 6 }}>
                            <RequestPageIcon sx={{ color: '#fc9803', fontSize: 90 }} />
                            <Typography variant="h5" sx={{ mt: 2 }}>No tiene ordenes pendientes</Typography>
                        </Box>
                    )}
                </Paper>
            )}
        </Container>
    );
}

export default ListDocument;